const CareerRouter = [
  {
    path: '/career-banner',
    name: 'ManageCareerIntroduce',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Career/ManageBanner.vue'),
    meta: {
      openSidebarKey: 'career',
      title: 'Quản lý banner page career'
    }
  },

  {
    path: '/career-our-life',
    name: 'ManageCareerOurLife',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Career/ManageOurLife.vue'),
    meta: {
      openSidebarKey: 'career',
      title: 'Quản lý our life'
    }
  },

  {
    path: '/career-candidates',
    name: 'ManageUserApply',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Career/ListCandidates/index.vue'),
    meta: {
      title: 'Danh sách ứng viên'
    }
  },

  // Chế độ đãi ngộ
  {
    path: '/career-remuneration-banner',
    name: 'ManageCareerRemunerationBanner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/CareerRemuneration/ManageBanner.vue'),
    meta: {
      openSidebarKey: 'career-remuneration',
      title: 'Quản lý banner chế độ đãi ngộ'
    }
  },

  // Thông tin tuyển dụng
  {
    path: '/career-recruitment-banner',
    name: 'ManageCareerRecruitmentBanner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/CareerInformation/ManageBanner.vue'),
    meta: {
      openSidebarKey: 'career-information',
      title: 'Quản lý banner thông tin tuyển dụng'
    }
  },
  {
    path: '/career-category',
    name: 'ManageCareerCategory',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/CareerInformation/ManageCategory.vue'),
    meta: {
      openSidebarKey: 'career-information',
      title: 'Quản lý ngành nghề tuyển dụng'
    }
  },
  // {
  //   path: '/career-position',
  //   name: 'ManageCareerPosition',
  //   layout: "dashboard",
  //   component: () => import('@/views/LandingPage/CareerInformation/ManagePosition.vue'),
  //   meta: {
  //     title: 'Quản lý vị trí tuyển dụng'
  //   }
  // },
  {
    path: '/career-recruitment',
    name: 'ManageRecruitment',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/CareerInformation/ManageRecruiment.vue'),
    meta: {
      openSidebarKey: 'career-information',
      title: 'Quản lý tin tuyển dụng'
    }
  },
  {
    path: '/career-recruitment/create',
    name: 'ControllerCreateRecruitment',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/CareerInformation/ControllerRecruiment.vue'),
    meta: {
      openSidebarKey: 'career-information',
      title: 'Thêm mới tin tuyển dụng'
    }
  },
  {
    path: '/career-recruitment/:id',
    name: 'ControllerUpdateRecruitment',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/CareerInformation/ControllerRecruiment.vue'),
    meta: {
      openSidebarKey: 'career-information',
      title: 'Cập nhật tin tuyển dụng'
    }
  },

  // Quy trình tuyển dụng
  {
    path: '/recruitment-process-banner',
    name: 'RecruitmentProcessBanner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/RecruitmentProcess/ManageBanner.vue'),
    meta: {
      openSidebarKey: 'recruitment-process',
      title: 'Quản lý banner quy trình tuyển dụng'
    }
  },
  {
    path: '/recruitment-process',
    name: 'ManageRecruitmentProcess',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/RecruitmentProcess/ManageProcess.vue'),
    meta: {
      openSidebarKey: 'recruitment-process',
      title: 'Quản lý các bước tuyển dụng'
    }
  },
  {
    path: '/recruitment-process/create',
    name: 'CreateRecruitmentProcess',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/RecruitmentProcess/ControllerProcess.vue'),
    meta: {
      openSidebarKey: 'recruitment-process',
      title: 'Thêm mới một quy trình tuyển dụng'
    }
  },
  {
    path: '/recruitment-process/:id',
    name: 'UpdateRecruitmentProcess',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/RecruitmentProcess/ControllerProcess.vue'),
    meta: {
      openSidebarKey: 'recruitment-process',
      title: 'Cập nhật quy trình tuyển dụng'
    }
  },

  // Môi trường làm việc
  {
    path: '/work-enviroment-banner',
    name: 'WorkEnviromentBanner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/WorkEnviroment/ManageBanner.vue'),
    meta: {
      openSidebarKey: 'work-enviroment',
      title: 'Quản lý banner môi trường làm việc'
    }
  },

  {
    path: '/work-enviroment-training',
    name: 'WorkEnviromentTraining',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/WorkEnviroment/ManageTraining.vue'),
    meta: {
      openSidebarKey: 'work-enviroment',
      title: 'Quản lý hoạt động đào tạo'
    }
  },

  {
    path: '/work-enviroment-video',
    name: 'WorkEnviromentVideo',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/WorkEnviroment/VideoIntroduce.vue'),
    meta: {
      openSidebarKey: 'work-enviroment',
      title: 'Video giới thiệu môi trường làm việc'
    }
  },

  {
    path: '/work-enviroment-work-space',
    name: 'WorkEnviromentWorkSpace',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/WorkEnviroment/ManageWorkSpace.vue'),
    meta: {
      openSidebarKey: 'work-enviroment',
      title: 'Quản lý không gian làm việc'
    }
  },
]

export default CareerRouter;
